module.exports = __webpack_public_path__ + "img/volks.43f7a02a.png";